module.exports = __webpack_public_path__ + "static/img/business-card.c691de1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/business-card.jpg
// module id = K+jH
// module chunks = 1